const MAP = {
  active: { label: "Active", cls: "bg-emerald-100 text-emerald-700" },
  pending: { label: "Pending", cls: "bg-amber-100 text-amber-700" },
  suspended: { label: "Suspended", cls: "bg-rose-100 text-rose-700" },
  rejected: { label: "Rejected", cls: "bg-slate-200 text-slate-600" },
  trial: { label: "Trial", cls: "bg-indigo-100 text-indigo-700" },
  expired: { label: "Expired", cls: "bg-rose-100 text-rose-700" },
  // orders
  new: { label: "New", cls: "bg-blue-100 text-blue-700" },
  accepted: { label: "Accepted", cls: "bg-indigo-100 text-indigo-700" },
  preparing: { label: "Preparing", cls: "bg-amber-100 text-amber-700" },
  ready: { label: "Ready", cls: "bg-teal-100 text-teal-700" },
  completed: { label: "Completed", cls: "bg-emerald-100 text-emerald-700" },
  cancelled: { label: "Cancelled", cls: "bg-slate-200 text-slate-500" },
  // payments
  paid: { label: "Paid", cls: "bg-emerald-100 text-emerald-700" },
  unpaid: { label: "Unpaid", cls: "bg-slate-200 text-slate-600" },
  created: { label: "Not completed", cls: "bg-slate-100 text-slate-500" },
  failed: { label: "Failed", cls: "bg-rose-100 text-rose-700" },
};

export function StatusBadge({ status, testId }) {
  const s = MAP[status] || { label: status, cls: "bg-slate-100 text-slate-600" };
  return (
    <span
      data-testid={testId || `status-${status}`}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold capitalize ${s.cls}`}
    >
      {s.label}
    </span>
  );
}
